import React, { Component } from 'react'
import { connect } from 'react-redux';

import { customSecondsElapsedSkAq } from "./actions/targetsActionNewFlow";

class Timer extends Component {

    componentDidMount = () => {        
        this.props.newIncrementerSkAq.map((obj, index) => {
            return clearInterval(this.props.newIncrementerSkAq[this.props.index]);
        })
        if (this.props.isStartSkAq[this.props.index]) {
            this.props.customSecondsElapsedSkAq("mount", this.props.index)
        } 
    }

    componentWillUnmount = () => {        
        this.props.incrementerSkAq.map((obj, index) => {
            return clearInterval(this.props.incrementerSkAq[this.props.index]);
        })
        if (this.props.isStartSkAq[this.props.index]) {
        this.props.customSecondsElapsedSkAq("unmount", this.props.index)
        }
    }

    getSeconds = (index) => {
        return ('0' + this.props.secondsElapsedSkAq[index] % 60).slice(-2)
    }

    getMinutes = (index) => {
        return Math.floor(this.props.secondsElapsedSkAq[index] / 60)
    }

    render() {
        return (
            <div>
                {this.getMinutes(this.props.index)}:{this.getSeconds(this.props.index)}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        isStartSkAq: state.patientSkillAcqActiveTarget.isStartSkAq,
        secondsElapsedSkAq:  Object.assign({}, state.patientSkillAcqActiveTarget.secondsElapsedSkAq),
        incrementerSkAq: state.patientSkillAcqActiveTarget.incrementerSkAq,
        newIncrementerSkAq: state.patientSkillAcqActiveTarget.newIncrementerSkAq
    }
}

export default connect(mapStateToProps, {customSecondsElapsedSkAq})(Timer);




// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/SkillAquisition/components/targets/Timer.js